import React from "react";
import styles from "../../../styles/pages/profile/ProfilePage.module.css";

const ReviewsViewSkeleton = () => {
  return (
    <div className={styles.contentSection}>
      <div className={styles.sectionHeader}>
        <div>
          <div className={`${styles.skeleton} ${styles.skeletonTitle}`}></div>
          <div
            className={`${styles.skeleton} ${styles.skeletonSubtitle}`}
          ></div>
        </div>
      </div>

      <div className={styles.reviewsGrid}>
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className={styles.reviewCard}>
            <div className={styles.reviewCardHeader}>
              <div
                className={`${styles.skeleton} ${styles.skeletonText}`}
                style={{ width: "60%" }}
              ></div>
              <div
                className={`${styles.skeleton} ${styles.skeletonText}`}
                style={{ width: "30%" }}
              ></div>
            </div>
            <div
              className={`${styles.skeleton} ${styles.skeletonText}`}
              style={{ width: "100%", height: "60px", marginTop: "10px" }}
            ></div>
            <div className={styles.reviewCardFooter}>
              <div
                className={`${styles.skeleton} ${styles.skeletonText}`}
                style={{ width: "40%" }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReviewsViewSkeleton;
